import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Check, Gift, Clock, ShieldCheck, Zap } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="bg-cream py-20 px-4 md:px-8 lg:px-16" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} data-id="element-92">
          {/* Urgency header */}
          <div className="text-center mb-8" data-id="element-93">
            <h2 className="text-2xl md:text-3xl font-serif font-extrabold text-navy mb-2" data-id="element-94">
              Todo lo que necesitás para reconectarte con tu hijo
            </h2>
            <p className="text-gray-600" data-id="element-95">
              Un solo pago. Sin suscripciones. Tuyo para siempre.
            </p>
          </div>

          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-amber" data-id="element-96">
            {/* Badge */}
            <div className="bg-terracotta text-white text-center py-2 px-4 text-sm font-bold tracking-wide" data-id="element-97">
              🔥 OFERTA ESPECIAL — AHORRÁS $29.010
            </div>

            <div className="p-8 md:p-10" data-id="element-98">
              <h3 className="text-xl font-serif font-extrabold text-navy mb-6 text-center" data-id="element-99">
                PACK RECONEXIÓN
              </h3>

              {/* Items with values */}
              <div className="space-y-4 mb-8" data-id="element-100">
                <div className="flex items-start space-x-3 bg-cream/60 p-4 rounded-lg" data-id="element-101">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-102" />
                  <div className="flex-1" data-id="element-103">
                    <span className="text-navy font-bold" data-id="element-104">
                      Guía "Del Silencio a la Confianza"
                    </span>
                    <span className="text-gray-500 text-sm block" data-id="element-105">
                      El sistema completo de 7 días paso a paso
                    </span>
                  </div>
                </div>

                <div className="flex items-start space-x-3 bg-cream/60 p-4 rounded-lg" data-id="element-106">
                  <Gift className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" data-id="element-107" />
                  <div className="flex-1" data-id="element-108">
                    <span className="text-navy font-bold" data-id="element-109">
                      BONUS: "¿Rebeldía o Ansiedad?"
                    </span>
                    <span className="text-gray-500 text-sm block" data-id="element-110">
                      Detectá señales de alerta a tiempo
                    </span>
                  </div>
                </div>

                <div className="flex items-start space-x-3 bg-cream/60 p-4 rounded-lg" data-id="element-111">
                  <Gift className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" data-id="element-112" />
                  <div className="flex-1" data-id="element-113">
                    <span className="text-navy font-bold" data-id="element-114">
                      BONUS: "La Noche y la Calle"
                    </span>
                    <span className="text-gray-500 text-sm block" data-id="element-115">
                      Kit de negociación para salidas y horarios
                    </span>
                  </div>
                </div>
              </div>

              {/* Price */}
              <div className="text-center mb-6" data-id="element-116">
                <span className="text-gray-400 line-through text-xl" data-id="element-117">
                  $49.000
                </span>
                <div className="text-5xl font-extrabold text-navy mt-1" data-id="element-118">
                  $19.990{' '}
                  <span className="text-lg text-gray-500 font-normal" data-id="element-119">ARS</span>
                </div>
                <p className="text-terracotta font-semibold text-sm mt-1" data-id="element-120">
                  Pago único · Sin cargos ocultos
                </p>
              </div>

              {/* CTA */}
              <CTAButton className="w-full text-lg md:text-xl py-5" data-id="element-121">
                <span className="block font-extrabold" data-id="element-122">
                  SÍ, QUIERO EL PACK AHORA →
                </span>
              </CTAButton>

              {/* Trust signals */}
              <div className="mt-6 flex items-center justify-center gap-6" data-id="element-123">
                <div className="flex items-center space-x-1.5" data-id="element-124">
                  <Zap className="w-4 h-4 text-amber" data-id="element-125" />
                  <span className="text-xs text-gray-500 font-medium" data-id="element-126">
                    Acceso inmediato
                  </span>
                </div>
                <div className="flex items-center space-x-1.5" data-id="element-127">
                  <ShieldCheck className="w-4 h-4 text-amber" data-id="element-128" />
                  <span className="text-xs text-gray-500 font-medium" data-id="element-129">
                    Garantía 7 días
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}